export const features = [
  { id: 'search.view', title: 'View search settings', module: 'search' },
  { id: 'search.manage', title: 'Manage search settings', module: 'search' },
  { id: 'search.reindex', title: 'Reindex search data', module: 'search' },
  { id: 'search.embeddings.view', title: 'View embedding settings', module: 'search' },
  { id: 'search.embeddings.manage', title: 'Manage embedding settings', module: 'search' },
  { id: 'search.global', title: 'Use global search (Cmd+K)', module: 'search' },
]

export default features
